module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAJ1BMVEUAAACQmKaSpLaZmaqRl6aRmKWRmKaRmae/v7+RmKaQmKaRl6eQl6UUj2svAAAADHRSTlMAyA0P6+WVfwTJgYJHhaAFAAAA9UlEQVRIx+3VMQ6CUAzG8Re5Aa4OujjLyAHcHB2dnD2Ag7uJq5dw8BImiIM9lAmR/hPKBxegEy3098h7pKQpiOv+GIvr7cOvn/Zadu/PFvbx5GCWdx9Ymb092RkEgFWenQwCwGoygwCgh1S1kMeOWKAhkhKgJABqAqAoAKoCoByAQAjAiXlKBQABsckcEASAIP4LaaJZh1okAAQBIAmAGOXIA9nYEgUvKYFBomw36j4A5IUi2mPM5F63xygIvgMnBAAhAAgBQAgAQgAQAoBQAIQAICRAh54HtMQxCFGLQepEJUaxE4ziSwME4uvJrf93cE5TePwAvkMGnDtE5AYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/input_close.png
// module id = xw0t
// module chunks = 54